var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoungfemale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 241,
    viewBox: "0 0 241 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.5 0C187.05 0 241 53.95 241 120.5C241 187.05 187.05 241 120.5 241C53.95 241 0 187.05 0 120.5C0 53.95 53.95 0 120.5 0Z",
    fill: "#F35B04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.11 169.156C97.11 169.156 73.747 171.422 52.777 177.652C52.777 177.652 37.858 180.448 37.999 205.262C37.999 205.262 81.338 236 121.999 236C163.659 236 202.651 208.663 202.651 208.663C202.651 208.663 207.368 185.34 181.076 174.651C181.076 174.651 155.178 168.017 145.666 167.032L97.11 169.156Z",
    fill: "#99C7E2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.1116 145.794C59.1116 145.794 57.8096 103.494 82.3336 41.725C82.3336 41.725 98.7656 15.142 141.445 28.982C141.445 28.982 164.632 36.805 168.89 75.707L181.556 147.918L139.334 152.165L69.6676 150.042C69.6676 150.042 64.1786 147.918 59.1116 145.794Z",
    fill: "#0D0B0B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.4434 173.404C84.4434 173.404 92.9374 196.377 118.221 196.766C118.221 196.766 150.992 197.439 162.554 175.528L154.11 173.404C154.11 173.404 129.53 206.288 88.6664 171.28L84.4434 173.404Z",
    fill: "#53B8F3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.443 141.546V160.661C103.443 160.661 102.247 169.829 90.7773 173.404C90.7773 173.404 90.9883 191.421 111.888 194.642C111.888 194.642 130.043 196.377 137.221 192.519C137.221 192.519 152.562 190.713 154.11 175.528C154.11 175.528 143.414 170.537 139.332 164.909L137.221 141.546H103.443Z",
    fill: "#FFE1D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.555 48.0969C143.555 48.0969 126.631 49.5479 120.333 48.0969C114.035 46.6459 105.52 48.2739 103.444 48.0969C101.368 47.9199 98.7646 46.5749 97.1106 48.0969C95.4566 49.6189 86.5546 67.2109 86.5546 67.2109C86.5546 67.2109 80.1866 105.193 88.6666 126.679C88.6666 126.679 98.7646 145.121 114 152.165C114 152.165 126.209 155.741 135.111 145.794C135.111 145.794 150.276 135.776 154.111 118.184L152 67.2109C152 67.2109 152.844 59.5659 143.555 48.0969Z",
    fill: "#FFE1D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoungfemale);
export default __webpack_public_path__ + "static/media/youngfemale.728ad972906ac236c8decbb355009fca.svg";
export { ForwardRef as ReactComponent };